// src/components/ProjectTracker/LazyGanttDisplay.jsx
import React, { lazy, Suspense } from 'react';

const GanttDisplay = lazy(() => import('../GanttDisplay'));

export default function LazyGanttDisplay(props) {
  return (
    <Suspense fallback={<div>Loading Gantt Chart...</div>}>
      <GanttDisplay {...props} />
    </Suspense>
  );
}
